import { en, es} from '../assets/language'
import { mapGetters } from 'vuex'


export default {
    methods: {
        $textTranslate(en, es){
            switch (this.lang) {
                case "ES": return es;
                case "EN": return en;
            }
            return en
        },
        $getKey(key){
            key ??= ''
            let lan = es
            switch (this.lang) {
                case "ES": lan = es; break
                case "EN": lan = en; break
            }
            if(key.split('.').length == 1)
                return key
                
            let [module, submodule, label] = key.split('.')
            if(key.split('.').length > 2){
                [module, submodule, label] = key.split('.')
                //if (lan[module]?.hasOwnProperty(submodule) && lan[module][submodule]?.hasOwnProperty(label)) {
                if (Object.prototype.hasOwnProperty.call(lan[module], submodule) && Object.prototype.hasOwnProperty.call(lan[module][submodule], label)) {
                //if (lan.hasOwnProperty(module) && lan[module].hasOwnProperty(submodule) && lan[module][submodule].hasOwnProperty(label)) {
                    return lan[module][submodule][label]
                }
            } else {
                [module, label] = key.split('.')
                //if (lan.hasOwnProperty(module) && lan[module].hasOwnProperty(label)) {
                if (Object.prototype.hasOwnProperty.call(lan, module) && Object.prototype.hasOwnProperty.call(lan[module], label)) {
                    return lan[module][label]
                }
            }
            
            return label== null? key: label
        },
        $changeLanguage(lang){
            this.$store.dispatch("lang/setLang", lang)
        },
        $lang(){
            return this.lang
        }
    },
    computed: {
        ...mapGetters('lang', [
            'lang' // This assumes 'lang' is the name of the getter you want to map
          ])
    }
}